// extracted by mini-css-extract-plugin
export default {"hero":"business_hero__bX8Ii","heroAccent":"business_heroAccent__FF5EB"};